import { createNavigation } from 'next-intl/navigation';
import { routing } from './routing';

// Locale-aware navigation helpers. `Link` accepts a `locale` prop to switch
// language while preserving the current path; `usePathname` returns the path
// WITHOUT the locale prefix.
export const { Link, redirect, usePathname, useRouter, getPathname } = createNavigation(routing);
